export default __webpack_public_path__ + "static/8-84eeda4c52219cbd5a1c65a5607a9301.jpg";